import React, { useState } from "react";
import ConfirmActionModal from "./ui/ConfirmActionModal";
import "./BottomBar.css"; // retain your existing CSS file

const BottomBar = ({ buttons, customContent }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [pendingAction, setPendingAction] = useState(null);

  const handleClick = (button) => {
    if (button.disabled) return;

    const label = button.label.toLowerCase();
    if (label === "validate & lock" || label === "validate & complete") {
      setPendingAction(() => button.onClick);
      setModalMessage(
        "Successful validation will lock the request and make it uneditable. Do you want to proceed?"
      );
      setModalVisible(true);
    } else {
      button.onClick();
    }
  };

  const confirmAction = () => {
    if (pendingAction) pendingAction();
    setModalVisible(false);
  };

  const leftButtons = buttons.filter((btn) =>
    ["back", "next"].includes(btn.label.toLowerCase())
  );

  const rightButtons = buttons.filter(
    (btn) => !["back", "next"].includes(btn.label.toLowerCase())
  );

  return (
    <>
      <div className="bottom-bar">
        <div className="left-buttons">
          {leftButtons.map((button, index) => (
            <button
              key={index}
              onClick={() => handleClick(button)}
              style={{
                backgroundColor:
                  button.label.toLowerCase() === "back" ? "#737373" : "",
                ...button.style,
                opacity: button.disabled ? 0.5 : 1,
                cursor: button.disabled ? "not-allowed" : "pointer",
              }}
              title={button.title}
              disabled={button.disabled}
            >
              {button.label}
            </button>
          ))}
        </div>

        {customContent && (
          <div className="custom-content" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {customContent}
          </div>
        )}

        <div className="right-buttons">
          {rightButtons.map((button, index) => (
            <button
              key={index}
              onClick={() => handleClick(button)}
              style={{
                backgroundColor:
                  button.label.toLowerCase() === "validate & lock" ||
                  button.label.toLowerCase() === "validate & complete"
                    ? "#ff4d4f"
                    : button.label.toLowerCase() === "delete"
                    ? "red"
                    : "",
                color:
                  button.label.toLowerCase() === "delete" ? "white" : "white",
                ...button.style,
                opacity: button.disabled ? 0.5 : 1,
                cursor: button.disabled ? "not-allowed" : "pointer",
              }}
              title={button.title}
              disabled={button.disabled}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>

      <ConfirmActionModal
        visible={modalVisible}
        message={modalMessage}
        onConfirm={confirmAction}
        onCancel={() => setModalVisible(false)}
      />
    </>
  );
};


export default BottomBar;
